import { render, staticRenderFns } from "./PeoplePermissions.vue?vue&type=template&id=3b82cbde&scoped=true"
import script from "./PeoplePermissions.vue?vue&type=script&lang=ts"
export * from "./PeoplePermissions.vue?vue&type=script&lang=ts"
import style0 from "./PeoplePermissions.vue?vue&type=style&index=0&id=3b82cbde&prod&lang=css"
import style1 from "./PeoplePermissions.vue?vue&type=style&index=1&id=3b82cbde&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b82cbde",
  null
  
)

export default component.exports